export var viewBoxPadding = function (viewBox, padding) {
    var _a, _b, _c, _d, _e, _f;
    var x = viewBox.x, y = viewBox.y, height = viewBox.height, width = viewBox.width;
    if (width <= 0 || height <= 0)
        return viewBox;
    if (typeof padding == "number") {
        return {
            x: x + padding,
            y: y + padding,
            width: width - (padding * 2),
            height: height - (padding * 2)
        };
    }
    return {
        x: x + ((_a = padding.left) !== null && _a !== void 0 ? _a : 0),
        y: y + ((_b = padding.top) !== null && _b !== void 0 ? _b : 0),
        width: width - (((_c = padding.right) !== null && _c !== void 0 ? _c : 0) + ((_d = padding.left) !== null && _d !== void 0 ? _d : 0)),
        height: height - (((_e = padding.top) !== null && _e !== void 0 ? _e : 0) + ((_f = padding.bottom) !== null && _f !== void 0 ? _f : 0))
    };
};
export var color_random = function () {
    var rangeR = getRandom(100, 220);
    var rangeG = getRandom(50, 150);
    var rangeB = getRandom(190, 255);
    return "rgb(" + rangeR + ", " + rangeG + ", " + rangeB + ")";
};
var getRandom = function (min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
};
